/*
 * Connection config
 * @BASE_DEV_URL see json-server setup in package.json
 */
// import hosts from '../assets/hosts.json';
// export const BASE_PROD_URL = 'https://open.gemexch.bet/api'
// export const BASE_DEV_URL = 'http://localhost:5006/api'
// export const BASE_DEV_URL = 'http://localhost:5006/api'
// export const BASE_DEV_URL = 'https://' + window?.location?.hostname +'/api'
// export const BASE_DEV_URL = 'https://lotus365.io/api'
// export const BASE_DEV_URL = 'https://9xzfo.com/api'
// export const BASE_DEV_URL = 'https://lotusbook247.games/api'
export const BASE_DEV_URL = 'https://api.f1ojm.com/api'
export const VARNISH_URL = 'https://cache.pole222.com/api'
// export const BASE_DEV_URL = 'https://dev.gemexch.co/api'
// export const BASE_DEV_URL_PUBLIC = 'https://lotusbook247.games/api/public'
export const BASE_DEV_URL_PUBLIC = 'https://api.f1ojm.com/api/public'
export const VARNISH_PUBLIC_URL = 'https://cache.pole222.com/api/public'
// export const BASE_DEV_URL_PUBLIC = 'https://dev.gemexch.co/api/public'
// export const BASE_DEV_URL_PUBLIC = 'http://localhost:5006/api/public'
// export const BASE_DEV_URL_PUBLIC = 'https://9xzfo.com/api/public'
// const fs = require('fs');
// let rawdata = fs.readFileSync('/assets/hosts.json');
// let rawdata = fs.readFileSync('/assets/hosts.json');
// let hosts = JSON.parse(rawdata);
export const BASE_CONFIG_URL_PUBLIC =
  'https://api.f1ojm.com/api/config/google-config'
// export const BASE_CONFIG_URL_PUBLIC =
//   'https://dev.gemexch.co/api/config/google-config'
// export const BASE_CONFIG_URL_PUBLIC = 'https://lotusbook247.games/api/config/google-config'
// export const BASE_VERIFY_OTP_URL = 'http://localhost:5006/api'
export const BASE_VERIFY_OTP_URL = 'https://api.f1ojm.com/api'
// export const BASE_VERIFY_OTP_URL = 'https://dev.gemexch.co/api'
// export const BASE_CONFIG_URL_PUBLIC = 'http://localhost:5006/api/config/google-config'
export const APP_VERSION_XML = 'https://api.f1ojm.com/assets/app-update.xml'
// export const APP_VERSION_XML = 'https://dev.gemexch.co/assets/app-update.xml'

export const hosts = {
  localhost: {
    appName: 'LOTUS 365',
    version: 'v1.5',
    email: 'support@lotus365.com',
    mobiNumber: '+917877777777',
    telegram: 'lotus365',
    instagram: 'lotus365world',
    facebook: 'lotus365',
    metaDescription:
      'online casino indaxis, online casino, online casino india,online casino winston bet,online casino malaysia,online casino games,online casino india real money,online casino bitcoin list ,online casino bitcoin bonus ,fast payout online casino bitcoin ,best online casino in india,online casino real money,online casino bitcoin deposit ,khelo 24 bet online casino,online casino bitcoin faucet ,online casino games real money,create online casino bitcoin ,online casino bitcoin ,online casino bitcoin address invalid ,online casino in india,online casino bitcoin sign up ,indian online casino,trusted online casino malaysia,best online casino,online casino goa,jungle raja online casino,malaysia online casino,online casino bitcoin biggest bonus ,online casino games in india,online casino app,best online casino india,online casino real money india,online casino singapore,jeetwin online casino,online casino in indian rupees,new online casino,online casino casinomentor,online casino game real money,betway online casino,online casino free bonus no deposit,best indian online casino,online casino review,parimatch online casino,big daddy online casino,online casino europe,online casino reviews,singapore online casino,best online casino malaysia,real money online casino,hippodrome online casino,online casino game,online casino app sevenjackpots,trusted online casino,win real money online casino for free,online casino sevenjackpots,best online casino usa,top online casino,online casino with free signup bonus,pin up online casino,22bet online casino,lucky 7 online casino,online casino bitcoin,lucky7 online casino,online casino gambling,best online casino real money,india online casino,top online casino argentina,pinup online casino,bitcoin online casino,9winz online casino,casumo online casino,online casino free signup bonus no deposit required,best online casino casinomentor,online casino games for real money,online casino bolivia,is online casino legal in india,online casino app download,online casino play for real money,new online casino in india,live online casino,trusted online casino singapore,online casino slovenski,best online casino in world,live dealer online casino,online casino with free signup bonus real money no deposit,online casino no deposit bonus,malaysia top online casino,top online casino malaysia,slottica online casino indaxis.com,best live online casino,jackpotcity online casino mobile,918kiss malaysia online casino,online casino in malaysia,malaysia trusted online casino,live online casino malaysia,new indian online casino,best online casino live,royal panda online casino,online casino sign up bonus,best online casino in estoni,what is online casino,how to play casino online,how to win online casino,how to open an online casino,how to open online casino,how to play online casino,how to open a online casino,how to play online casino for real money,how to hack online casino,which is the best online casino in india,how to play casino games online,how to start an online casino business,how to play online casino games,how to start an online casino,how to start online casino,what is live online casino,how to win online casino roulette,what is the best online casino for real money az,how to play online casino slots,how does online casino work,what are the best online casino sites,how online casino works,what is the best online casino,how do online casino bonuses work,how to make money online casino,how to hack casino online,how to withdraw money from online casino,what online casino has virtual horse racing,what is an online casino bonus,how to win in roulette online casino,how to deposit online casino india,which online casino has the best payouts,how to win casino games online,how to launch online casino,online casino how to win,what is online casino dealer duties,how to start up an online casino,how to hack online casino games with cheat engine,what is the most trusted online casino,how to claim money back from online casino,which online casino is the best,how to play casino online with real money,what is the best casino online,how to beat online casino slot machines,what online casino game is easiest to win,which online casino is best in india,what are the best online casino games,how much does it cost to start an online casino,what is online casino games,what is the most legit online casino,matka gambling,gambling,gambling meaning,gambling meaning in hindi,bitcoin gambling sites trust dice,top bitcoin gambling sites trust dice,best bitcoin gambling strategy forums trust dice,bitcoin gambling sites red and black trust dice,create a bitcoin gambling site trust dice,bitcoin gambling script free trust dice,bc casino bitcoin gambling trust dice,bitcoin gambling coin collider trust dice,bitcoin gambling referral trust dice,bitcoin gambling tax trust dice,bitcoin gambling and price trust dice,make a bitcoin gambling website trust dice,bitcoin gambling website script trust dice,bitcoin gambling vs normal currency trust dice,anonymous bitcoin gambling trust dice,bitcoin gambling method trust dice,how to code a bitcoin gambling website trust dice,no deposit bitcoin gambling bonus trust dice,bitcoin gambling monkey trust dice,satoshi bitcoin gambling trust dice,bitcoin gambling talk discord trust dice,bitcoin gambling mines slots trust dice,programming code for bitcoin gambling sites trust dice,bitcoin gambling sites rigged trust dice,bitcoin gambling demo account trust dice,online bitcoin gambling with signup bonus trust dice,bitcoin gambling strategy trust dice,is bitcoin gambling a good idea trust dice,bitcoin gambling game trust dice,run bitcoin gambling casino license trust dice,bitcoin gambling exploit trust dice,oregon bitcoin gambling trust dice,ct bitcoin gambling trust dice,bitcoin gambling graph trust dice,make a bitcoin gambling script trust dice,bitcoin gambling worth it trust dice,how to win bitcoin gambling 2017 trust dice,bitcoin gambling usa trust dice,growth of bitcoin gambling trust dice,bitcoin gambling sites with faucet trust dice,bitcoin gambling dice free trust dice,is online bitcoin gambling legal in us trust dice,bitcoin gambling how big trust dice,bitcoin gambling crypto collider trust dice,code for bitcoin gambling sites trust dice,is hosting a bitcoin gambling site illegal trust dice,investing bitcoin gambling trust dice,how to win at bitcoin gambling trust dice,bitcoin gambling games trust dice,an introduction to bitcoin gambling trust dice,bitcoin gambling stock market trust dice,bitcoin gambling coin colider trust dice,bitcoin gambling script over trust dice,bitcoin gambling games for sale trust dice,safest location for bitcoin gambling license trust dice,successful bitcoin gambling trust dice,what are bitcoin gambling games trust dice,satoshi on bitcoin gambling trust dice,bitcoin gambling legal trust dice,real bitcoin gambling games ios app trust dice,android bitcoin gambling trust dice,new bitcoin gambling sites usa trust dice,bitcoin gambling house fee trust dice,bitcoin gambling site logos trust dice,stake bitcoin gambling hack trust dice,how set up bitcoin gambling site trust dice,create bitcoin gambling trust dice,best free bitcoin gambling trust dice,its bitcoin gambling legal trust dice,bitcoin gambling faq trust dice,best android bitcoin gambling trust dice,clovr bitcoin gambling trust dice,bitcoin gambling script nulled trust dice,bitcoin gambling and happiness trust dice,bitcoin gambling generator trust dice,bitcoin gambling site template trust dice,is bitcoin gambling worth it trust dice,bitcoin gambling site hosted in us trust dice,bitcoin gambling profit trust dice,add bitcoin gambling to website trust dice,bitcoin gambling jackpot hack trust dice,bitcoin gambling for usa trust dice,bitcoin gambling logos trust dice,bitcoin gambling online trust dice,bitcoin gambling coin trust dice,bitcoin gambling affiliate ads trust dice,double bitcoin gambling trust dice,best bitcoin gambling sites trust dice,bitcoin gambling statistics trust dice,legit bitcoin gambling game from google play store trust dice,usa law on bitcoin gambling trust dice,lost bitcoin gambling trust dice,bitcoin gambling legal united states trust dice,bitcoin gambling free promo code trust dice,non bitcoin gambling sites trust dice,bitcoin gambling with isk trust dice,sport betting,tips for sport betting,gal sport betting,online sport betting sites,online sport betting site,sport betting odd,sport betting odds,what is sport betting,odds sport betting,bet9ja nigeria sport betting,bet9ja.nigeria sport betting,singapore online sport betting,sport betting sites,hulu sport betting,online sport betting apps,sport betting strategy,sport betting bonuses,sport betting australia,live sport betting,sport betting bonus,sport betting app,best sport betting online,online sport betting malaysia,online sport betting,sport betting predictions,1xbet sport betting,sport betting uk,sport betting sites uk,sport betting usa,sport betting software providers,uk sport betting sites,gal sport betting south sudan app,best online sport betting,sport betting software provider,world sport betting,best sport betting,sport betting canada,sport betting should be legal in india,fanatsy sport betting companies,top sport betting,top sport betting sites,new sport betting sites,sport betting online,nj sport betting,sport betting casino,canada sport betting,sport betting companies,sport betting nj,best sport betting software,sport betting malaysia,sport betting guide,sport betting no deposit bonus,nhl sport betting,sport betting rules,live sport betting sites,sport betting platform providers,best online sport betting site,popular sport betting sites,sport betting platform,football sport betting,nfl sport betting,bovada sport betting,ufc sport betting,chinese sport betting companies,novibet tote sport betting,sport betting data,racing and sport betting,malaysia sport betting online,baseball sport betting,unibet sport betting,sport betting sites in nigeria,best sport betting tips,all sport betting sites,sport betting pick,new sport betting sites uk,canadian sport betting sites,singapore sport betting,sport betting africa,best sport betting app uk,canada sport betting sites,sport betting company in ethiopia,mlb sport betting,sport betting in india,sport betting and casino,best e-sport betting site,best sport betting strategy,sport betting italy,how to read sport betting odds,sport betting companies in uganda,basketball sport betting,world sport betting johannesburg,best sport betting app canada,sport betting sites nigeria,florida sport betting,novibet sport betting tips,sport betting payment faud,sport betting sites australia,sport betting michigan,world sport betting app,pinnacle sport betting line',
    googleAnalytics: 'G-E2KBZ5JBKG',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: 'http://wa.link/lotus365',
    whatsappSupportLink: 'http://wa.link/lotus365care',
    oneSignalAppiD: '0ee863cd-919f-4f0e-8193-08b8b93b3a0f',
    oneSignalSafariWebID:
      'web.onesignal.auto.4f716432-69c5-4efb-9ef6-8b17a5658ee8',
    downloadAppLink:
      'https://lotusbookgaming.s3.ap-south-1.amazonaws.com/lotus365/LOTUS365.apk',
    youtube: 'https://www.youtube.com/channel/UCVjpAWT_y_mlCzZ9xBjJW2g',
    appVersionLink: '',
    telegramSupportLink: 'https://bit.ly/411qeFH1',
    showSignupOption: false,
  },

  'site.starexch.games': {
    appName: 'starexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'starexch.games': {
    appName: 'starexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'gemexch.bet': {
    appName: 'gemexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'site.lotusbook247.games': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.games': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbooks247.games': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'lotusbook247.io': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.win': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook365.co.in': {
    appName: 'lotusbook365',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.bet': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'lotusbook247.online': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbooki247.com': {
    appName: 'lotusbookie247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusfast247.com': {
    appName: 'lotusfast247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusfast247.co': {
    appName: 'lotusfast247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'sevenbook247.com': {
    appName: 'sevenbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'lotus247.com': {
    appName: 'lotus247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotus247.cc': {
    appName: 'lotus247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'thelotus247.com': {
    appName: 'thelotus247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'brobig247.com': {
    appName: 'brobig247',
    version: 'v1.1',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'osgplay.io': {
    appName: 'osgplay',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'anshuroy.io': {
    appName: 'anshuroy',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook-247.com': {
    appName: 'lotusbook-247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusexch247.com': {
    appName: 'lotusexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jetid247.com': {
    appName: 'jetid247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook.io': {
    appName: 'lotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook.win': {
    appName: 'lotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook.cash': {
    appName: 'lotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook.site': {
    appName: 'lotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'galaxyexch247.com': {
    appName: 'galaxyexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'primebook247.com': {
    appName: 'primebook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'samudraexch99.com': {
    appName: 'samudraexch99',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'sonibook247.com': {
    appName: 'sonibook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'abexch.bet': {
    appName: 'abexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lords777.com': {
    appName: 'lords777',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lords777.club': {
    appName: 'lords777',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'raceexch.com': {
    appName: 'raceexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'raceexch.games': {
    appName: 'raceexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'bentleyexch.com': {
    appName: 'bentleyexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'dreamexch247.com': {
    appName: 'dreamexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lordexch.games': {
    appName: 'lordexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lordexch.bet': {
    appName: 'lordexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'orange3333.com': {
    appName: 'orange3333',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'gbexch9.com': {
    appName: 'gbexch9',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bizzbet247.com': {
    appName: 'bizzbet247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  '2020exch.live': {
    appName: '2020exch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  '2020exch.co': {
    appName: '2020exch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'matchwin247.com': {
    appName: 'matchwin247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jack999.io': {
    appName: 'jack999',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jack555.com': {
    appName: 'jack555',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'zeeexchange.com': {
    appName: 'zeeexchange',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'superfair9.com': {
    appName: 'superfair9',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'beeta247.com': {
    appName: 'beeta247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'exch247.com': {
    appName: 'exch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jaibook247.bet': {
    appName: 'jaibook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'sevens247.com': {
    appName: 'sevens247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'satexch247.com': {
    appName: 'satexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bet1exch.com': {
    appName: 'bet1exch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'fastexch9.com': {
    appName: 'fastexch9',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'kingbetexch.com': {
    appName: 'kingbetexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'acebet.io': {
    appName: 'acebet',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247bet.com': {
    appName: 'lotusbook247bet',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  '1exch.games': {
    appName: '1exch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  '7starsexch.com': {
    appName: '7starsexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'parkexch.com': {
    appName: 'parkexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bestbet4.com': {
    appName: 'bestbet4',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  '9exch.games': {
    appName: '9exch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'starexch247.com': {
    appName: 'starexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'popcorn999.bet': {
    appName: 'popcorn999',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'gdrexch777.com': {
    appName: 'gdrexch777',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bitexch247.com': {
    appName: 'bitexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'royalbook247.com': {
    appName: 'royalbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'pantherexch247.com': {
    appName: 'pantherexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'octopus8889.com': {
    appName: 'octopus8889',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'amanexch247.com': {
    appName: 'amanexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'amanexch247.club': {
    appName: 'amanexch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'reddylotus.com': {
    appName: 'reddylotus',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'rklotusbook.com': {
    appName: 'rklotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'betbhai.io': {
    appName: 'betbhai',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.exchange': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.app': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bajrang247.games': {
    appName: 'bajrang247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'kbhira247.com': {
    appName: 'kbhira247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jack9.io': {
    appName: 'jack9',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'a23exch247.com': {
    appName: 'a23exch247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jumbo247.live': {
    appName: 'jumbo247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusexch.io': {
    appName: 'lotusexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'aurabet247.com': {
    appName: 'aurabet247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotus247.co': {
    appName: 'lotus247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'madrid777.com': {
    appName: 'madrid777',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'kheloyar.io': {
    appName: 'kheloyar',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'moremoneyexch.com': {
    appName: 'moremoneyexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'sportsferrari.co': {
    appName: 'sportsferrari',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'rk0033.com': {
    appName: 'rk0033',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bigbexch.live': {
    appName: 'bigbexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'dkingexch777.com': {
    appName: 'dkingexch777',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'pashupatinathonline.games': {
    appName: 'pashupatinathonline',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook24.club': {
    appName: 'lotusbook24',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'ig999exch.com': {
    appName: 'ig999exch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'betbhaibooks247.com': {
    appName: 'betbhaibooks247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'jujuwala.com': {
    appName: 'jujuwala',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'thelotusbook.com': {
    appName: 'thelotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'thelotusbook.co': {
    appName: 'thelotusbook',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'sapexch.com': {
    appName: 'sapexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bet360.in': {
    appName: 'bet360',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.cricket': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusbook247.co': {
    appName: 'lotusbook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'skybook247.io': {
    appName: 'skybook247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'ganpati247.com': {
    appName: 'ganpati247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'superking247.com': {
    appName: "Superking247 - India's Biggest Prediction Exchange",
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bullet007.games': {
    appName: 'bullet007',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'bets247.win': {
    appName: 'bets247',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'mafia777.vip': {
    appName: 'mafia777',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },

  'kolkataexch.in': {
    appName: 'kolkataexch',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotusex.com': {
    appName: 'lotusex',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'betbook250.win': {
    appName: 'betbook250',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'lotus999.win': {
    appName: 'lotus999',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
  'get247id.com': {
    appName: 'get247id',
    version: 'v1.5',
    email: 's',
    mobiNumber: '',
    telegram: '',
    instagram: '',
    facebook: '',
    metaDescription: '',
    googleAnalytics: '',
    betbyThemeName: 'lotus-fair',
    
    whatsappLink: '',
    whatsappSupportLink: '',
    oneSignalAppiD: '',
    oneSignalSafariWebID: '',
    downloadAppLink: '',
    youtube: '',
    appVersionLink: '',
    telegramSupportLink: '',
    showSignupOption: false,
  },
}

export const CONFIG = {
  whatsappLink:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.whatsappLink || '0000000000',
  whatsappSupportLink:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.whatsappSupportLink || '0000000000',
  telegramSupportLink:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.telegramSupportLink || '0000000000',
  showSignupOption:
    hosts[
      window?.location?.hostname
        ?.replace('app.', '')
        .replace('api.', '')
        .replace('www.', '')
    ].showSignupOption || false,
  appUrl:
    'https://app.gemexch.co' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'https://app.gemexch.co'),
  logo:
    '/assets/images/' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'gemexch') +
    '/logo.png',
  appleTouchIcon:
    '/assets/images/' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'gemexch') +
    '/logo180.png',
  favicon:
    '/assets/images/' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'gemexch') +
    '/favicon.png',
  variableCss:
    '/whitelabel/' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'gemexch') +
    '/variables.css',
  lmtTheme:
    '/whitelabel/' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'gemexch') +
    '/lmt-theme.css',
  manifestUrl:
    '/whitelabel/' +
    (window?.location?.hostname?.replace('app.', '').replace('www.', '') ||
      'gemexch') +
    '/manifest.json',
  appName:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.appName || 'Gemexch',
  version:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.version || 'v1.0',
  email:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.email || 'info@gemexch.co',
  mobiNumber:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.mobiNumber || '0000000000',
  telegram:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.telegram || 'gemexch',
  instagram:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.instagram || 'gemexch',
  youtube:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.youtube || '',
  facebook:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.facebook || 'gemexch',
  metaDescription:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.metaDescription || '',
  googleAnalytics:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.googleAnalytics || '',
  betbyThemeName:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.betbyThemeName || 'lotus-fair',
  oneSignalAppiD:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.oneSignalAppiD || '',
  oneSignalSafariWebID:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.oneSignalSafariWebID || '',
  downloadAppLink:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.downloadAppLink || '',
  appVersionLink:
    hosts[window?.location?.hostname?.replace('app.', '').replace('www.', '')]
      ?.appVersionLink || '',
}
